import { useMemo } from 'react'

import { ModalContext } from '@domain-group/suit-theme'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateOrEditTagModal from '@modals/CreateOrEditTagModal'

import PageContent from './components/PageContent'

type DefaultState = {
  showCreateOrEditTagModal: boolean,
}

type SetState = (state: Partial<DefaultState>) => void

const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    CreateOrEditTagModal: {
      closeModal: () => setState({ showCreateOrEditTagModal: false }),
      createTag: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updateTag: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState: DefaultState = {
  showCreateOrEditTagModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showCreateOrEditTagModal,
  } = state

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateOrEditTagModal: (payload: object) => {
        setModalData('CreateOrEditTagModal', payload)
        setState({ showCreateOrEditTagModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateOrEditTagModal
          callbacks={callbacks('CreateOrEditTagModal', setState)}
          showModal={showCreateOrEditTagModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
